module.exports = __webpack_public_path__ + "img/type3.62c6c441.png";